var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){_vm.dialogTableVisible=true}}},[_vm._t("default")],2),_c('el-dialog',{attrs:{"title":"选择代理区域","destroy-on-close":"","visible":_vm.dialogTableVisible},on:{"update:visible":function($event){_vm.dialogTableVisible=$event}}},[_c('YChooseAreaPro',{attrs:{"mode":_vm.mode},on:{"change":_vm.change}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }